import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "flex-center pright-16px" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["onClick"]

import { computed, ref, watch } from 'vue';
import { ItemSelect } from '@/models/share.model';
import SharedService from "@/services/SharedService";
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'esSelectInput',
  props: {
    options: {},
    selectedData: {},
    isFiltered: { type: Boolean, default: true }
  },
  emits: ['changeSelect'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const searchInput = ref<string>("");
const newItem = ref<string>("");

const emits = __emit;

const {t} = useI18n();

const filteredOptions = computed(() => {
  if (props.isFiltered) {
    let filteredItemSelectList: ItemSelect[] = [];

    let searchString = searchInput.value.trim();
      if (searchString.length < 1) {
        return props.options;
      }

      const searchParts = searchString.toUpperCase().split(" ")
      props.options.some(option => {
        const matchesSearch = searchParts.every(part => option.label.toUpperCase().includes(part))
        if (matchesSearch) {filteredItemSelectList.push(option)}
        return false
      })
      return filteredItemSelectList;
  }

  return props.options;
})

const search = () => {
  //Clean
  newItem.value = "";

  if (!props.options.some((option: ItemSelect) => option.label.trim() === searchInput.value.trim())) {
    //Auto-Open
    newItem.value = searchInput.value;
  }
}

const setNewItem = () => {
  emits('changeSelect', {
    id: null,
    label: newItem.value
  });
}

const selectItem = (itemSelected: ItemSelect) => {
  emits('changeSelect', itemSelected);
}

watch(
    () => props.selectedData,
  async () => {
    if (props.selectedData) {
      searchInput.value = props.selectedData.label;
    }
  }
);


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_listGroup = _resolveComponent("listGroup")!
  const _component_inputComboBox2 = _resolveComponent("inputComboBox2")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_inputComboBox2, {
      ref: "searchInputRef",
      class: "w-full",
      modelValue: searchInput.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchInput).value = $event)),
      onInput: _cache[2] || (_cache[2] = ($event: any) => (search())),
      autoFocus: false,
      minHeight: true
    }, {
      post: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _unref(SharedService).getIcon('chevron-down', false, 'shareIcons'),
            class: "square-14"
          }, null, 8, _hoisted_3)
        ])
      ]),
      dropd: _withCtx(() => [
        (newItem.value)
          ? (_openBlock(), _createBlock(_component_listGroup, {
              key: 0,
              styles: "pad-s",
              class: "pleft-06 h-48",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (setNewItem()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_text_item, {
                  txt: _unref(t)('common.newInput', {inputValue: newItem.value}),
                  styles: "main-m"
                }, null, 8, ["txt"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredOptions.value, (item, index) => {
          return (_openBlock(), _createBlock(_component_listGroup, {
            key: index,
            styles: "pad-m",
            class: "pleft-06 h-48"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "row w-full",
                onClick: ($event: any) => (selectItem(item))
              }, [
                _createVNode(_component_text_item, {
                  txt: item.label
                }, null, 8, ["txt"])
              ], 8, _hoisted_4)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})